import * as Ably from "ably";
import { requestAblyAuth } from "_shared/_stores/realtime/ably-auth";

let realtimeClient: Ably.Realtime | undefined;

export const createAblyRealtimeClient = (): Ably.Realtime => {
  const websocketOnly = (
    globalThis as typeof globalThis & {
      __ATTORNEY_HUB_E2E_ABLY_WEBSOCKET_ONLY__?: boolean;
    }
  ).__ATTORNEY_HUB_E2E_ABLY_WEBSOCKET_ONLY__;
  return new Ably.Realtime({
    authCallback: (_tokenParams, callback) => {
      void requestAblyAuth()
        .then((authResponse) => callback(null, authResponse as Ably.TokenDetails | Ably.TokenRequest | string))
        .catch((error: unknown) => callback(error instanceof Error ? error.message : "Ably authentication failed.", null));
    },
    autoConnect: false,
    closeOnUnload: true,
    echoMessages: false,
    ...(websocketOnly ? { transports: ["web_socket" as const] } : {}),
  });
};

export const getAblyRealtimeClient = (): Ably.Realtime => {
  realtimeClient ??= createAblyRealtimeClient();
  return realtimeClient;
};

/**
 * A Realtime instance keeps the first authenticated clientId for its lifetime. Replace the shared
 * instance when the browser session changes principal so the next auth callback can establish a
 * different identified client.
 */
export const replaceAblyRealtimeClient = (): Ably.Realtime => {
  realtimeClient = createAblyRealtimeClient();
  return realtimeClient;
};

export const resetAblyRealtimeClientForTests = () => {
  realtimeClient = undefined;
};
